import * as Yup from 'yup';

export const EditEnquiryAutoRenewSchema = Yup.object().shape({
  autoRenewUntil: Yup.string()
    .label('Auto-renew until')
    .required('Auto-renew until is required'),
  jobEndDate: Yup.string()
    .label('Job end date')
    .required('Job end date is required'),
  autoRenewEvery: Yup.string()
    .label('Auto-renew this many days before expiry')
    .required()
});
